<app-modal-basic #modal [hideFooter]='true' (closed)="onClose()">
  <div class="app-modal-header">
    <h4 class="modal-title">
      <i class="modal-title icofont icofont-file-alt m-r-5"></i>
      Selecione a operação desejada
    </h4>
    <button type="button" class="close basic-close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <div class="col-12 gap-4 d-flex flex-column">
      <div class="row">
        <button type="button" style="text-transform: none;" (click)="imprimirColetaEstoque()"
          class="btn w-100 m-0 btn-primary" [disabled]="loading['impressao-coleta']">
          <app-loading [loading]="loading['impressao-coleta']" [icone]="''"
            texto="Relatório de coleta de estoque"></app-loading>
        </button>
      </div>

      <div class="row">
        <button type="button" style="text-transform: none;" class="btn w-100 m-0 btn-primary" (click)="emissaoNFe()"
          [disabled]="true || loading['nfse']">
          <app-loading [loading]="loading['nfse']" [icone]="''" texto="Emissão de NF-e"></app-loading>
        </button>
      </div>

      <div class="row">
        <button type="button" style="text-transform: none;" class="btn w-100 m-0 btn-primary"
          (click)="minutaTransporte()" [disabled]="true || loading['minuta-transporte']">
          <app-loading [loading]="loading['minuta-transporte']" [icone]="''" texto="Minuta de transporte"></app-loading>
        </button>
      </div>

      <div class="row justify-content-end">
        <button (click)="close()" [disabled]="loading['registro'] || loading['disable'] || loading['parametros']"
          class="btn btn-primary btn-outline-primary mr-0">
          <i class="icofont icofont-arrow-left"></i> Voltar
        </button>
      </div>
    </div>
  </div>
  <div class="app-modal-footer"></div>
</app-modal-basic>